import {useMutation} from 'react-query'

import {API} from '../../networking/http'
import {ValidatePromoCodeBody, ValidatePromoCodeResponse} from './types'

export const validatePromoCodeEndpoint = 'promo-codes/validate'

export const validatePromoCode = (body: ValidatePromoCodeBody) =>
  API.post<ValidatePromoCodeBody, ValidatePromoCodeResponse>(validatePromoCodeEndpoint, body).then((res) => res.data)

export const useValidatePromoCode = () => useMutation(validatePromoCode)
